export const CONSTANTS = {
  features: [
    {
      label: "Customized Network Design and Deployment",
      text: "Crafting solutions that align with specific business requirements and future growth.",
    },
    {
      label: "Integration of Advanced Security Protocols",
      text: "Implementing measures to protect data and ensure compliance with industry standards.",
    },
    {
      label: "Comprehensive Support and Maintenance",
      text: "Providing ongoing assistance to keep networks running smoothly and efficiently.",
    },
  ],
  title: "Why choose OneMind for wired | wireless networking solutions?",
  description: [
    "OneMind Services specializes in delivering tailored wired and wireless networking solutions designed to meet the unique needs of businesses across various sectors. Our offerings include:",
  ],
  extraContent:
    "By leveraging the latest technologies and best practices, OneMind Services ensures that your wired and wireless networks are robust, secure, and scalable, empowering your business to thrive in a connected world.",
};
